import {deletee, get, patch, post} from "./index";

export const getDirectGroupsList = (params) => {
  const request = {
    subUrl: `/direct_groups.json`,
    params,
  };
  return get(request);
};

export const creatDirectGroups = (data) => {
  const request = {
    subUrl: `/direct_groups.json`,
    data,
  };
  return post(request);
};

export const deleteDirectGroups = (params) => {
  console.log("parm", params);
  const request = {
    subUrl: `/direct_groups/${params.id}`,
  };
  return deletee(request);
};
export const addClinicianDirectGroups = (params) => {
  console.log("parm", params);
  const request = {
    subUrl: `/direct_groups/${params.id}`,
    data: {
      address_book_ids: params.address_book_ids,
      name: params.name,
    },
  };
  return patch(request);
};
